// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d314ea1","455":"c0b376ab"}[chunkId] + ".chunk.js";
};